import { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { SeoLink } from 'dibs-seo/exports/SeoLink';
import ResponsiveImage from '../ResponsiveImage';
import HpLazyImageWrapper from '../HpLazyImageWrapper/HpLazyImageWrapper';

import styles from './HpRespCollectionSpotlightItem.scss';

import { HpRespCollectionSpotlightItem_item } from './__generated__/HpRespCollectionSpotlightItem_item.graphql';

type Props = {
    item: HpRespCollectionSpotlightItem_item;
    useLazyLoadImages: boolean;
    onClick: () => void;
};

const HpRespCollectionSpotlightItem: FC<Props> = ({ onClick, item, useLazyLoadImages }) => {
    const { linkData, title, image } = item;
    return (
        <SeoLink
            className={styles.link}
            dataTn="maker-item-tile"
            linkData={linkData}
            onClick={onClick}
        >
            <div className={styles.item}>
                <HpLazyImageWrapper
                    useLazyLoad={useLazyLoadImages}
                    imageWidth={image?.imageWidth}
                    imageHeight={image?.imageHeight}
                >
                    <ResponsiveImage
                        ariaHidden
                        className={styles.image}
                        src={image?.imageUrl || ''}
                        srcSetWidths={[240, 360]}
                    />
                </HpLazyImageWrapper>
                <div className={styles.title}>{title}</div>
            </div>
        </SeoLink>
    );
};

export default createFragmentContainer(HpRespCollectionSpotlightItem, {
    item: graphql`
        fragment HpRespCollectionSpotlightItem_item on CollectionSpotlightItem {
            title
            linkData {
                ...SeoLink_linkData
            }
            image {
                imageUrl
                imageWidth
                imageHeight
            }
        }
    `,
});
